import { TagVariant } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ExportStateEnum } from '@mews-commander/data-access';
import { TooltippedTag } from '@mews-commander/ui';

export const StatusTag = ({ status, note }: { status: ExportStateEnum; note: string }) => {
    const mapStatusToTagAndTextkey: Record<ExportStateEnum, { textKey: Mews.TextKey; variant: TagVariant }> = {
        [ExportStateEnum.Pending]: {
            textKey: TextKey.Pending,
            variant: 'basicSubtle',
        },
        [ExportStateEnum.Processing]: {
            textKey: TextKey.Processing,
            variant: 'basicSubtle',
        },
        [ExportStateEnum.Success]: {
            textKey: TextKey.Success,
            variant: 'success',
        },
        [ExportStateEnum.Failed]: {
            textKey: TextKey.Failed,
            variant: 'danger',
        },
        [ExportStateEnum.TimedOut]: {
            textKey: TextKey.TimedOut,
            variant: 'warning',
        },
    };

    return (
        <TooltippedTag tooltip={note} variant={mapStatusToTagAndTextkey[status].variant}>
            <LocalizedText textKey={mapStatusToTagAndTextkey[status].textKey} />
        </TooltippedTag>
    );
};
